module.exports = __webpack_public_path__ + "img/burger.3d78bfd8.svg";